"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchAlphalendMarketUpdateEventsSentio = fetchAlphalendMarketUpdateEventsSentio;
const dailyRevenue_1 = require("../analytics/crons/dailyRevenue");
const TVL_1 = require("../analytics/crons/TVL");
const sentioClient_js_1 = require("./sentioClient.js");
async function fetchAlphalendMarketUpdateEventsSentio(startTime, endTime) {
    // Define 2-week interval in milliseconds
    const TWO_WEEKS_MS = 14 * 24 * 60 * 60 * 1000;
    // If the time range is within 2 weeks, use the original single API call
    if (endTime - startTime <= TWO_WEEKS_MS) {
        return fetchAlphalendMarketUpdateEventsSentioChunk(startTime, endTime);
    }
    // Split into 2-week chunks aligned to date boundaries
    let allEvents = [];
    let currentStart = (0, TVL_1.getStartOfDayGMT)(startTime);
    while (currentStart < endTime) {
        // Calculate chunk end, but align to end of day to avoid date boundary issues
        const rawChunkEnd = currentStart + TWO_WEEKS_MS;
        const currentEnd = Math.min((0, dailyRevenue_1.getEndOfDayGMT)(rawChunkEnd), endTime);
        const chunkEvents = await fetchAlphalendMarketUpdateEventsSentioChunk(currentStart, currentEnd);
        allEvents.push(...chunkEvents);
        // Move to start of next day to avoid overlapping date boundaries
        currentStart = (0, TVL_1.getStartOfDayGMT)(currentEnd + 1);
        // Add a small delay between requests to avoid rate limiting
        if (currentStart < endTime) {
            await new Promise((resolve) => setTimeout(resolve, 1000));
        }
    }
    // Sort all events by timestamp to maintain chronological order
    allEvents.sort((a, b) => a.timestamp - b.timestamp);
    // ignore market id 25
    // patch fix
    allEvents = allEvents.filter((event) => event.market !== 25);
    return allEvents;
}
async function fetchAlphalendMarketUpdateEventsSentioChunk(startTime, endTime) {
    const startDate = new Date(startTime).toISOString().split("T")[0];
    const endDate = new Date(endTime).toISOString().split("T")[0];
    const sql = `
    WITH ranked_events AS (
      SELECT 
        date(timestamp) AS date,
        timestamp,
        CAST(JSON_VALUE(fields, '$.event.market_id') AS INT) AS market,
        '0x' || JSON_VALUE(fields, '$.event.coin_type.name') AS coin_type,
        event_seq AS seq,
        JSON_VALUE(fields, '$.event.balance_holding') AS balance_holding,

        ROW_NUMBER() OVER (
          PARTITION BY date(timestamp), CAST(JSON_VALUE(fields, '$.event.market_id') AS INT)
          ORDER BY timestamp DESC, event_seq DESC
        ) AS rn
      FROM \`sui.events\`
      WHERE type = '0xd631cd66138909636fc3f73ed75820d0c5b76332d1644608ed1c85ea2b8219b4::events::Event<0xd631cd66138909636fc3f73ed75820d0c5b76332d1644608ed1c85ea2b8219b4::market::MarketDataUpdateEvent>'
        AND date(timestamp) <= '${endDate}'
        AND date(timestamp) >= '${startDate}'
    )
    SELECT date, toUnixTimestamp64Milli(timestamp) AS timestamp, seq, market, coin_type, balance_holding
    FROM ranked_events
    WHERE rn = 1
    ORDER BY timestamp ASC;`;
    return await (0, sentioClient_js_1.executeSentioQuery)(sql);
}
//# sourceMappingURL=lastDayMarketUpdateEvents.js.map